import React from "react";
import { format, isToday, isYesterday } from "date-fns";

const TimestampConverter = ({ time, callFrom }) => {
  const date = new Date(time * 1000);
  const currentDate = Date.now();
  if (callFrom === "userCard") {
    if (isToday(date)) {
      const formattedTime = format(date, "hh:mm a", { timeZone: "Asia/Kolkata" });
      return <span>{formattedTime}</span>;
    } else {
      const formattedDate = format(date, "dd MMM yyyy", {
        timeZone: "Asia/Kolkata",
      });
      return <span>{formattedDate}</span>;
    }
  }
  if (callFrom === "chatHistory") {
    const formattedDate = format(date, "hh:mm a", {
      timeZone: "Asia/Kolkata",
    });
    return <span>{formattedDate}</span>;
  }
};

export default TimestampConverter;
